export const codigosSucesso = ['33'];
export const codigosAlerta = ['07', '09','35','29'];
export const codigosErro = ['08', '10', '11', '12', '13', '16', '21', '26','31','32'];
